import React, { useState } from "react";
import {
  Box, Paper, Typography, Divider, Button, Dialog, DialogTitle, DialogContent, DialogActions
} from "@mui/material";
import { FaUserShield } from "react-icons/fa";

const AboutPane = () => {
  const [openPolicy, setOpenPolicy] = useState(false);

  return (
    <Box sx={{ p: 2 }}>
      <Paper sx={{ p: 2 }}>
        <Typography variant="h6">About the App</Typography>
        <Divider sx={{ my: 1 }} />
        <Typography variant="body2" sx={{ mb: 1 }}>
          All labour law content in one place: Acts, Rules, Notifications, Circulars,
          Judgements, Blogs, and a Compliance view with events and videos.
        </Typography>
        <Typography variant="body2" sx={{ mb: 2 }}>
          Consultants can upload and manage documents. Clients can browse content and track updates.
        </Typography>
        <Button startIcon={<FaUserShield />} variant="outlined" onClick={() => setOpenPolicy(true)}>
          Privacy Policy & Disclaimer
        </Button>
      </Paper>

      <Dialog open={openPolicy} onClose={() => setOpenPolicy(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Privacy Policy & Disclaimer</DialogTitle>
        <DialogContent dividers>
          <Typography variant="body2" sx={{ mb: 1 }}>
            We respect your privacy. Uploaded content is processed to deliver requested features.
          </Typography>
          <Typography variant="body2">
            Information is general guidance. Verify with official notifications before acting.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenPolicy(false)}>Close</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default AboutPane;
